import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.css' ]
})
export class LoginComponent implements OnInit {

   public loginForm: FormGroup;

   constructor(
      private fb: FormBuilder,
      private auth: AuthService,
      private router: Router
   ) {}

   ngOnInit() {
      this.initForm();
   }

   initForm() {
      this.loginForm = this.fb.group({
         'username': ['', Validators.required],
         'password': ['', Validators.required]
      });
   }

   onSubmitLogin(value: any) {

      const username = value.username;
      const password = value.password;

      // alert("SUBMITTING..." + "\n" +
      //      "email: " + username + "\n" +
      //      "password: " + password);

      // call the AuthService login method, that returns an Observable<any>
      this.auth.login(username, password).subscribe(
         user => {
            // alert("YOU SUCCESSFULLY LOGGED IN");
            console.log("Successful signIn: user = " + JSON.stringify(user, null, 2));
            this.router.navigate(['/chooseapp']);         // go to the home page/component
         },
         error => {
            alert("Username e/o password errati.\nSe hai dimenticato la tua password, seguendo il link sottostante puoi recuperarla.");
            console.log("Failed signIn: error = " + JSON.stringify(error, null, 2));
         }
      );

   }  // end onSubmitLogin

}  // end LoginComponent
